import { Component, OnInit } from '@angular/core';
import {BreadcrumbsService} from '../../services/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-info-aifa-page',
  templateUrl: './info-aifa-page.component.html',
  styleUrls: ['./info-aifa-page.component.scss']
})
export class InfoAifaPageComponent implements OnInit {

  public breadcrumbLabel = $localize`:info-aifa-page|breadcrumb-text-link@@info-aifa-page.breadcrumb-text:Cosa è AIFA Medicinali`;

  testo =$localize`:info-aifa-page|text-page@@info-aifa-page.text-page:AIFA Medicinali è un servizio di 
  informazione sui medicinali ad uso umano autorizzati in Italia realizzato dall'Agenzia Italiana del Farmaco.
  <br>
  <br> 
  Consente di consultare il Foglio Illustrativo (FI), con le informazioni su composizione, posologia, 
  malattie o condizioni per cui il farmaco è indicato, e il Riassunto delle Caratteristiche del Prodotto 
  (RCP), destinato principalmente agli operatori sanitari, in cui sono riportate le informazioni fondamentali 
  relative all'efficacia e alla sicurezza dei medicinali.
  <br>
  <br>
  Il cittadino e l'operatore sanitario possono inoltre trovare informazioni sulla rimborsabilità del medicinale 
  da parte del Servizio Sanitario Nazionale (SSN), sulla necessità o meno della prescrizione del medico e su 
  eventuali carenze nella fornitura alle farmacie.
  <br>
  <br>
  Tutti i documenti pubblicati sono approvati dall'AIFA.`;

  info = {
    title: $localize`:info-aifa-page|title-text@@info-aifa-page.title-text:Cosa è AIFA Medicinali`,
    text: this.testo
  };

  constructor(private breadcrumbService: BreadcrumbsService) {
  }



  ngOnInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    this.breadcrumbService.pushUrl({label: this.breadcrumbLabel, routerLink: '/info_aifa'});
  }



}
